import { render, staticRenderFns } from "./TopBarAdmin.vue?vue&type=template&id=9983091c&scoped=true&"
import script from "./TopBarAdmin.vue?vue&type=script&lang=js&"
export * from "./TopBarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TopBarAdmin.vue?vue&type=style&index=0&id=9983091c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9983091c",
  null
  
)

export default component.exports